import Router from 'vue-router';
import Vue from 'vue';

Vue.use(Router);

/**
 * Oops
 * @see https://github.com/pillarjs/path-to-regexp/issues/106#issuecomment-302869563
 */

export default new Router({
    mode  : 'history',
    base  : process.env.BASE_URL,
    routes: [{
        path     : '/',
        name     : 'genplan',
        component: () => {
            return import('./pages/Genplan/Genplan.vue');
        }
    }, {
        path     : '/complex',
        name     : 'complex',
        component: () => {
            return import('./pages/Building/Building.vue');
        }
    }, {
        path     : '/complex/building/:buildingId',
        name     : 'section',
        component: () => {
            return import('./pages/Section/Section.vue');
        }
    }, {
        path     : '/complex/building/:buildingId/section/:sectionId',
        name     : 'floor',
        component: () => {
            return import('./pages/Floor/Floor.vue');
        }
    }, {
        path     : '/complex/section/:sectionId',
        name     : 'floor',
        component: () => {
            return import('./pages/Floor/Floor.vue');
        }
    }, {
        path     : '/complex/building/:building/section/:sectionId/floor/:floorId',
        name     : 'flat',
        component: () => {
            return import('./pages/Flat/Flat.vue');
        }
    }, {
        path     : '/complex/section/:sectionId/floor/:floorId',
        name     : 'flat',
        component: () => {
            return import('./pages/Flat/Flat.vue');
        }
    }]
});
